import React, { Fragment } from 'react';
import { Table, Modal, ModalHeader, ModalBody } from 'reactstrap';


const InsuranceBenefit = ({ isOpen, toggle, insuranceBenefits, name = 'Insurance', type = '' }) => {
    const safeType = String(type || '').toLowerCase().trim();
    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} backdrop="static" style={{ maxWidth: "700px" }}>
                <ModalHeader toggle={toggle} style={{ borderBottom: "none", paddingBottom: "0px" }}>{name === "Assistance" ? "Assistance Benefits" : name === "Benefits" ? "Benefits" : "Insurance Benefits"}</ModalHeader>
                <ModalBody>
                    {/* {insuranceBenefits && insuranceBenefits.length > 0 ? (  */}
                    <>
                        {/* <ul>
                            {insuranceBenefits.map((benefits, index) => (
                                <li key={index}>{index + 1}. {benefits.service.title || 'No title available'}</li> 
                            ))}
                        </ul> */}
                        <Table>
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Sum Assured</th>
                                    <th>Deductible</th>
                                </tr>
                            </thead>
                            <tbody className="mtd-bg">
                                {insuranceBenefits && insuranceBenefits?.length > 0 ? (
                                    insuranceBenefits?.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ padding: "0.5rem" }}>{item?.service?.title || '-'}</td>
                                            <td style={{ padding: "0.5rem" }}>{safeType === 'assistance scheme 4' ? (item?.sum_assured_usd || item?.sum_insured_usd || item?.sum_assured || '-') : (item?.sum_insured_usd || item?.sum_assured || '-')}</td>
                                            <td style={{ padding: "0.5rem" }}>{safeType === 'assistance scheme 4' ? (item?.deductible_usd || item?.deductible || '-') : (item?.deductible_usd || item?.deductible || '-')}</td>
                                            {/* <td style={{ padding: "0.5rem" }}>{type.toLowerCase().trim() == 'assistance scheme 4' ? item?.sum_assured_usd : item?.sum_assured || '-'}</td>
                                            <td style={{ padding: "0.5rem" }}>{type.toLowerCase().trim() == 'assistance scheme 4' ? item?.deductible_usd : item?.deductible || '-'}</td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">No data found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </>
                    {/* ) : (
                        <p>No benefits available.</p>
                    )} */}
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default InsuranceBenefit;